import { attachmentSchema } from '@/config/request';
import { useQueryParameters } from '@/hooks/useQueryParameters';
import AttachmentsForm from '@oncolens/oncolens-ui/lib/components/Common/EventAttachments/AttachmentsForm';
import React from 'react';
import shallow from 'zustand/shallow';
import useRequestFormStore from '../../RequestFormStore';

const AttachmentsSection = () => {
  const [updateField, attachments] = useRequestFormStore(
    (store) => [store.updateField, store.attachments],
    shallow
  );
  const queryParameters = useQueryParameters();

  return (
    <AttachmentsForm
      schema={attachmentSchema}
      identifierKey="requestId"
      setValue={updateField}
      formAttachments={attachments}
      queryParameters={queryParameters}
      attachmentEventType="Collaboration Request"
    />
  );
};

export { AttachmentsSection as default };
